import { progressAnatomy as parts } from '@chakra-ui/anatomy';
import type { PartsStyleFunction } from '@chakra-ui/styled-system';

const baseStyle: PartsStyleFunction<typeof parts> = () => ({
  filledTrack: {
    bgColor: 'brand.red.light',
  },
});

const successVariant: PartsStyleFunction<typeof parts> = () => ({
  filledTrack: {
    bgColor: 'brand.green',
  },
});

const warningVariant: PartsStyleFunction<typeof parts> = () => ({
  filledTrack: {
    bgColor: 'brand.yellow',
  },
});

const defaultProps = {
  size: 'md',
  colorScheme: 'blue',
};

const variants = {
  success: successVariant,
  warning: warningVariant,
};

export default {
  parts: parts.keys,
  baseStyle,
  variants,
  defaultProps,
};
